export default __webpack_public_path__ + "static/media/rick-not-found.8630fa9b.jpg";